/* global $ */
/* global rfUrl */
/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

const MINIMUM_PW_LENGTH = 5;

/**
 * Determine if the customer is allowed to proceed to checkout
 *
 * @return {boolean}
 */
function customerCanCheckOut() {
  let canCheckout = false;
  const $rexiVerifiedForCheckout = $('#rexiVerfiedForCheckout').val();
  if ($('.comcast_quantity__input').length > 0) {
    if (
      parseInt($rexiVerifiedForCheckout, 10) < 4 ||
      $rexiVerifiedForCheckout === 'NaN'
    ) {
      canCheckout = true;
    }
  } else {
    canCheckout = true;
  }
  return canCheckout;
}


/**
 * Collect Order Instructions if entered and questionnaire answers, save to the order notes,
 * and proceed to checkout if the customer is valid
 *
 * @param {string} cartQuestionnaireAnswerValue
 */
function collectAndSaveOrderNotes(cartQuestionnaireAnswerValue) {
  let cartNoteText = '';
  const cartNote = document.querySelector('.cart-recap__note-inner .cart-note');
  if (cartNote) {
    cartNoteText += `${cartNote.value}\r\n`;
    //cartNoteText += '===========================\r\n';
  }
  //cartNoteText += 'Current Customer?\r\n';
  cartNoteText += cartQuestionnaireAnswerValue;
  fetch('/cart/update.js', {
    body: JSON.stringify({ note: cartNoteText }),
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
    },
  }).then((response) => {
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    window.location.href = '/checkout';
    return false;
  });
}

$(document).ready(() => {
  const checkoutForm = document.querySelector('.shopify-cart-form');

  // Prevent any other processes from taking over by listening to the cart submit event
  if (checkoutForm) {
    checkoutForm.addEventListener('submit', (event) => {
      event.preventDefault();
      event.stopPropagation();
      return false;
    });
  }

  const cartCheckoutButton = document.querySelector('button.maincart-checkout');
  const cartCheckoutButtonInitial = document.querySelector(
    'button.cart-checkout-btn'
  );
  const cartQuestionnaire = document.querySelector('.cart-questionnaire');
  const cartQuestionnaireError = document.querySelector(
    '.cart-questionnaire__error'
  );
  let cartQuestionnaireAnswerValue = false;

  if (cartCheckoutButton) {
    // If the initial cart checkout button is clicked, just display the error message
    cartCheckoutButtonInitial.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      cartQuestionnaire.classList.add('error');
      cartQuestionnaireError.classList.add('show');
      return false;
    });

    // If the active cart checkout button is clicked, do a sanity check and then process the
    // form
    cartCheckoutButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (cartQuestionnaire) {
        const cartQuestionnaireAnswer =
          cartQuestionnaire.querySelector('input:checked');
        if (cartQuestionnaireAnswer) {
          cartQuestionnaireAnswerValue = cartQuestionnaireAnswer.value;
          if (cartQuestionnaireAnswerValue && customerCanCheckOut()) {
            collectAndSaveOrderNotes(cartQuestionnaireAnswerValue);
            return false;
          }
        }
      }
      cartQuestionnaire.classList.add('error');
      cartQuestionnaireError.classList.add('show');
      return false;
    });
  }

  $(document).on('change', '.cart-questionnaire input', function () {
    if (customerCanCheckOut()) {
      cartQuestionnaire.classList.remove('error');
      cartQuestionnaireError.classList.remove('show');
      $(this).parents('form').find('button.cart-checkout-btn').hide();
      $(this).parents('form').find('button.maincart-checkout').show();
    }
  });

  // Activation Page
  const activationForm = document.getElementById('activate_customer_password');

  if (activationForm) {
    $('#activate_customer_password').validate({
      rules: {
        'customer[password]': {
          minlength: MINIMUM_PW_LENGTH,
        },
        'customer[password_confirmation]': {
          minlength: MINIMUM_PW_LENGTH,
        },
      },
    });
  }
});
